// src/AdminLogin.jsx
import React from "react";
import { useNavigate } from "react-router-dom";
import { db, auth } from "./firebase";
import { doc, getDoc } from "firebase/firestore";
import { signOut } from "firebase/auth";
import Login from "./Login";

export default function AdminLogin() {
  const navigate = useNavigate();

  const onLogin = async (user) => {
    // ✅ allow only admins/{uid}
    const adminSnap = await getDoc(doc(db, "admins", user.uid));
    if (!adminSnap.exists()) {
      await signOut(auth);
      throw new Error("This account is not registered as Admin.");
    }

    // ✅ go to admin route editor
    navigate("/admin");
  };

  return (
    <Login
      role="admin"
      title="Admin Login"
      subtitle="Admins only. Manage routes and updates."
      onLogin={onLogin}
    />
  );
}